import React, { useEffect, useState, Fragment } from 'react'
import * as Papa from 'papaparse'
import Product from './components/Product/Product'
import ProductReviews from './components/ProductReviews/ProductReviews'
import Loader from './components/Loader/Loader'
import './App.scss'
import {
    getProducts,
    mapOrder,
    PATTERNS,
    PRODUCT_TITLES,
} from './helpers/helpers'
import BundleProduct from './components/BundleProduct/BundleProduct'

const BOOST_URL =
    'https://services.mybcapps.com/bc-sf-filter/search?shop=monicaandandyonline.myshopify.com&limit=70&fuzzy=2&q='

const App = ({ slug, patternSlug, variantIdOnLoad, pdpBundle }) => {
    console.log('slug, variantIdOnLoad', slug, variantIdOnLoad)

    const [products, setProducts] = useState([])
    const [productsFromAPI, setProductsFromAPI] = useState([])
    const [variants, setVariants] = useState([])
    const [allVariants, setAllVariants] = useState([])
    const [mainProduct, setMainProduct] = useState([])
    const [hiddenProduct, setHiddenProduct] = useState([])
    const [isDev, setIsDev] = useState(false)
    const [bundleData, setBundleData] = useState()

    // prevent removing dashes from `one-piece`
    let op
    if (slug.match(/one-piece/)) {
        op = slug.match(/one-piece/)
    } else if (slug.match(/two-piece/)) {
        op = slug.match(/two-piece/)
    } else if (slug.match(/fleece-lined/)) {
        op = slug.match(/fleece-lined/)
    } else if (slug.match(/2-pack/)) {
        op = slug.match(/2-pack/)
    } else if (slug.match(/3-pack/)) {
        op = slug.match(/3-pack/)
    } else if (slug.match(/4-pack/)) {
        op = slug.match(/4-pack/)
    } else if (slug.match(/8-pack/)) {
        op = slug.match(/8-pack/)
    } else if (slug.match(/4-piece/)) {
        op = slug.match(/4-piece/)
    } else if (slug.match(/6-piece/)) {
        op = slug.match(/6-piece/)
    } else if (slug.match(/v-neck/)) {
        op = slug.match(/v-neck/)
    } else if (slug.match(/zip-up/)) {
        op = slug.match(/zip-up/)
    } else if (slug.match(/all-in-one/)) {
        op = slug.match(/all-in-one/)
    } else if (slug.match(/arms-out/)) {
        op = slug.match(/arms-out/)
    } else if (slug.match(/t-shirt/)) {
        op = slug.match(/t-shirt/)
    } else if (slug.match(/wimmer-ferguson/)) {
        op = slug.match(/wimmer-ferguson/)
    } else if (slug.match(/wimmer-ferguson/) && slug.match(/double-feature/)) {
        op = slug.match(/wimmer-ferguson/) && slug.match(/double-feature/)
    } else if (slug.match(/double-feature/)) {
        op = slug.match(/double-feature/)
    } else if (slug.match(/24-7/)) {
        op = slug.match(/24-7/)
    }

    let slugString

    if (op && op.length > 0) {
        let withoutOp
        if (
            op.toString() === '2-pack' ||
            op.toString() === '3-pack' ||
            op.toString() === '4-pack' ||
            op.toString() === '8-pack' ||
            op.toString() === '4-piece' ||
            op.toString() === '6-piece' ||
            op.toString() === 'zip-up' ||
            op.toString() === 'arms-out' ||
            op.toString() === 'v-neck' ||
            op.toString() === 'all-in-one' ||
            op.toString() === 't-shirt' ||
            op.toString() === 'wimmer-ferguson' ||
            op.toString() === 'double-feature' ||
            op.toString() === 'wimmer-ferguson-m-double-feature' ||
            op.toString() === '24-7'
        ) {
            withoutOp = slug.split(op)[1]
            // console.log('3-pack op, without op 3-pack', op, withoutOp)
            slugString = op + withoutOp.replace(/-/g, '%20')
        } else {
            op = op[0]
            withoutOp = slug.split(op)[0]
            // console.log('op, without op', op, withoutOp)
            slugString = withoutOp.replace(/-/g, '%20') + op
        }
    } else {
        slugString = slug.replace(/-/g, '%20')
    }

    console.log('slugString, slug', slugString, slug)

    let pages
    let productsFromData
    let variantsFromProducts = []

    useEffect(() => {
        // let variantsFromProducts = []
        const queryUrl = `${BOOST_URL}${slugString}`
        console.log('queryUrl', queryUrl)
        fetch(queryUrl).then((res) =>
            res.json().then((productData) => {
                console.log('productData', productData)

                let numberOfProducts = productData.total_product

                // calculate number of "pages" of data in collection
                if (numberOfProducts && numberOfProducts > 70) {
                    pages = Math.ceil(numberOfProducts / 70)
                    ;(async () => {
                        await getProducts(pages, queryUrl).then((products) => {
                            console.log('products', products)

                            setProductsFromAPI(products.products)
                        })
                    })()
                } else {
                    setProductsFromAPI(productData.products)
                }
            })
        )
    }, [slug, slugString])

    useEffect(() => {
        if (productsFromAPI) {
            console.log('productsFromAPI', productsFromAPI)

            productsFromData = productsFromAPI.filter((p) => {
                // console.log('slug', slug)
                return p.handle.indexOf(slug) > -1
            })

            console.log('productsFromData', productsFromData)

            let extraProducts = productsFromData.filter((p) => {
                return endsWithNumber(p.handle)
            })

            function endsWithNumber(str) {
                return isNaN(str.slice(-1)) ? false : true
            }

            let hiddenP = productsFromData.filter((p) => {
                return p.handle === slug && p.title.indexOf('hidden') > -1
            })

            console.log('hiddenP', hiddenP)

            setHiddenProduct(hiddenP)

            let printProducts = productsFromData.filter((p) => {
                return p.handle.indexOf('_') !== -1
            })

            // console.log('printProducts', printProducts)

            if (printProducts.length > 0) {
                productsFromData = printProducts
            }

            let mainProducts = productsFromData.filter((p) => {
                // return p.handle.split('_')[0] === slug && p.available
                return p.handle.split('_')[0] === slug

            })

            mainProducts = mainProducts.reverse()

            console.log('mainProducts', mainProducts)

            let otherProducts = productsFromData.filter((p) => {
                return p.handle.split('_')[0] !== slug
            })

            // console.log('otherProducts', otherProducts)

            let allProducts = [
                ...mainProducts,
                ...otherProducts,
                ...extraProducts,
            ]

            console.log('allProducts', allProducts)

            setProducts(allProducts)

            let mainP = []

            if (mainProducts.length > 0) {
                // console.log('mainProducts has length')
                if (variantIdOnLoad) {
                    // console.log('variantIdOnLoad in mainP', variantIdOnLoad)
                    let mainVariants = mainProducts.map((p) => {
                        return p.variants
                    }).flat(1)

                    // console.log('mainVariants', mainVariants)

                    let matchingProductId = mainVariants.map((v) => {
                        if (v.id.toString() === variantIdOnLoad.toString()) {
                            return v.product_id
                        }
                        return null
                    })

                    matchingProductId = matchingProductId.filter(Boolean)[0]

                    console.log('matchingProductId here', matchingProductId)

                    if (matchingProductId) {
                        mainP = mainProducts.filter((p) => {
                            return p.id.toString() === matchingProductId.toString()
                        })
                    }


                    console.log('mainP after variantIdOnLoad', mainP)
                } else {
                    mainP = [mainProducts[0]]
                }

            } else {
                mainP = productsFromData.filter((p) => {
                    return p.handle === slug
                })
            }

            console.log('mainP here', mainP)

            // console.log('mainProduct', mainP, allProducts, allProducts.length)

            if (mainP.length === 0) {
                mainP = [productsFromData[0]]
            }

            setMainProduct(mainP)

            allProducts.map((p) => {
                variantsFromProducts.push(p.variants)
                return null
            })

            variantsFromProducts = variantsFromProducts.flat(1)

            setAllVariants(variantsFromProducts)

            console.log('variantsFromProducts here', variantsFromProducts)

            if (allProducts.length === 1) {
                console.log('allProducts.length === 1', allProducts.length)
                setVariants(variantsFromProducts)
            } else {
                variantsFromProducts = variantsFromProducts.filter((v) => {
                    if (mainP && mainP.length > 0 && mainP[0].tags.includes('Disney100')) {
                        return v
                    } else if (v.product_type !== 'Virtual Classes') {
                        return v.inventory_quantity > 0
                    } else {
                        return v
                    }
                })

                let sortedArray = mapOrder(
                    variantsFromProducts,
                    PATTERNS,
                    'initial_color'
                )

                setVariants(variantsFromProducts)
            }
        }
    }, [productsFromAPI])

    useEffect(() => {
        if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
            setIsDev(true)
        } else {
            setIsDev(false)
        }
    }, [])

    return (
        <>
            {pdpBundle ? (
                <div className={`App PDP-App ${isDev ? 'development' : ''}`}>
                    <BundleProduct />
                </div>
            ) : (
                <div className={`App PDP-App ${isDev ? 'development' : ''}`}>
                    {products &&
                    products.length &&
                    variants &&
                    variants.length &&
                    mainProduct &&
                    mainProduct.length ? (
                        <Fragment>
                            <Product
                                products={products}
                                mainProduct={mainProduct}
                                hiddenProduct={hiddenProduct}
                                variants={variants}
                                variantIdOnLoad={variantIdOnLoad}
                                allVariants={allVariants}
                                patternSlug={patternSlug}
                            />
                        </Fragment>
                    ) : (
                        <Loader />
                    )}
                </div>
            )}
        </>
    )
}

export default App
